import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';

export const useRestoreCalendarEventMutation = () => {
  const queryClient = useQueryClient();

  const {
    mutateAsync,
    error,
    isPending: isLoading,
  } = useMutation<unknown, Error, string>({
    mutationFn: (id: string) => api.put(`calendar-events/${id}/restore`, {}),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['calendar-events'] });
    },
  });

  const restoreCalendarEvent = async (id: string) => {
    return mutateAsync(id);
  };

  return {
    restoreCalendarEvent,
    isLoading,
    error,
  };
};
